import { FAQLink } from 'components/RechargeInfoAlertModal/partials/FAQLink.component';
import { requestPDF } from 'pages/Recharge/Recharge.helpers';
import { HTMLAttributes } from 'react';
import { Translate } from 'react-localize-redux';
import colors from 'style-utils/colors';
import { mainSiteLinks } from 'utils/consts/main-site-links';
import { useIsApp } from 'utils/hooks/useGetIsApp';
import { LinkPdf, Note, UlNote } from './style/notePage.style';

export type NotePageProps = HTMLAttributes<HTMLDivElement> & {
  text: string;
  onClick?: () => void;
  hasPdf?: boolean;
  isBulletPointList?: boolean;
  hasFaqLink?: boolean;
  noNote?: boolean;
  containerPadding?: string;
  paddingUlNote?: string;
  borderColor?: string;
  borderSize?: string;
  textColor?: string;
  lineHeight?: string;
  size?: string;
  data?: Record<string, any>;
  faqFragment?: string;
  containerMargin?: string;
};

export default function NotePage({
  text,
  data,
  noNote,
  hasPdf,
  isBulletPointList,
  hasFaqLink,
  containerPadding = '0 0 0 15px',
  paddingUlNote = '0 0 16px 0',
  borderColor = colors.yellowNoteLight,
  borderSize = '5px',
  textColor = colors.blackTwelve,
  lineHeight = '16px',
  size = '14px',
  faqFragment = '',
  containerMargin,
  ...otherProps
}: NotePageProps) {
  const isApp = useIsApp();

  const buildNoteBody = () => {
    if (hasPdf) {
      return (
        <>
          <UlNote>
            <span>
              <ul>
                <li>
                  <Translate
                    id={'text.recharge.note2.bonificoBancario.titolare'}
                  />
                </li>
                <li>
                  <Translate
                    id={'text.recharge.note2.bonificoBancario.number'}
                  />
                </li>
                <li>
                  <Translate
                    id={'text.recharge.note2.bonificoBancario.limit'}
                  />
                </li>
                <li>
                  <Translate id={'text.recharge.bonificoBancario.note1'} />
                  <LinkPdf onClick={() => requestPDF(isApp)}>
                    <Translate id={'text.linkPdfSisal'} />
                  </LinkPdf>
                  <Translate id={'text.recharge.bonificoBancario.note2'} />
                </li>
              </ul>
              <Translate id={'lbl.recharge.notePageBonifico'} />
              <Translate
                id={'text.recharge.bonificoBancario.note3'}
                data={{
                  url: `${mainSiteLinks.topUpsFaq}${faqFragment}`,
                  rechargeinfo: `${mainSiteLinks.topUpsFaq}#importo-bonifico-bancario-non-accreditato`,
                }}
              />
            </span>
          </UlNote>
          {hasFaqLink && (
            <Translate
              id="text.recharge.refund.moreInfoFaq2"
              data={{ faqElement: <FAQLink fragment={faqFragment} /> }}
            />
          )}
        </>
      );
    }

    if (isBulletPointList) {
      return (
        <>
          <UlNote>
            <Translate id={text} {...(data && { data })} />
          </UlNote>
          {hasFaqLink && (
            <>
              <Translate
                id="text.recharge.refund.moreInfoFaq2"
                data={{ faqElement: <FAQLink fragment={faqFragment} /> }}
              />
            </>
          )}
        </>
      );
    }

    return <Translate id={text} {...(data && { data })} />;
  };

  return (
    <Note
      size={size}
      containerPadding={containerPadding}
      containerMargin={containerMargin}
      borderColor={borderColor}
      borderSize={borderSize}
      textColor={textColor}
      lineHeight={lineHeight}
      {...otherProps}
    >
      {!noNote && <strong>Note:&nbsp;</strong>}
      {buildNoteBody()}
    </Note>
  );
}
